if (!customElements.get('quick-shop')) {
  class Quickshop extends HTMLElement {
    constructor() {
      super();

      this.parentCard = this.closest('[data-product-card]');
      this.labelInitial = this.querySelector('[data-quickshop-label-initial]');
      this.labelInStock = this.querySelector('[data-quickshop-label-in-stock]');
      this.labelOutOfStock = this.querySelector('[data-quickshop-label-out-of-stock]');

      const clickHandler = ('ontouchstart' in document.documentElement ? "touchstart" : "click");

      // Bind popup toggle events
      this.parentCard.querySelectorAll('[data-quickshop-toggle]').forEach((button) =>
        button.addEventListener(clickHandler, this.onPopupToggle.bind(this))
      );

      // Bind option select events
      this.querySelectorAll('[data-quickshop-option]').forEach((option) =>
        option.addEventListener('click', this.onOptionSelect.bind(this, option.value, option.dataset.inventoryQuantity))
      );

      this.querySelectorAll('.options__option').forEach((option) => {
        const input = option.querySelector('input').dataset.inventoryQuantity;
        const label = option.querySelector('label');

        label.addEventListener('mouseover', this.onOptionHover.bind(this, input));
        label.addEventListener('mouseout', () => {
          this.labelInitial.classList.remove('not-visible');
          this.labelInStock.classList.add('not-visible');
          this.labelOutOfStock.classList.add('not-visible');
        });
      });
    }

    /**
     * Toggles the options popup
     * @description Renders the products based on the fetch url data.
     */
    onPopupToggle() {
      const popupIsOpenClass = 'quickshop--is-open';

      this.classList.toggle(popupIsOpenClass);
    }

    /**
     * Adds a variant to the cart
     * @description Adds the clicked option/variant to the cart leveraging the product form component.
     * @param {String} variantId
     * @param {String} inventoryQuantity
     */
    onOptionSelect(variantId, inventoryQuantity) {
      const productForm = this.querySelector('product-form');
      const hiddenId = productForm.querySelector('input[name="id"]');
      const hiddenInventoryQty = productForm.querySelector('input[name="inventory_quantity"]');
      const submitButton = productForm.querySelector('[type="submit"]');

      hiddenId.value = variantId;
      hiddenInventoryQty.value = inventoryQuantity;
      submitButton.click();
    }

    onOptionHover(inventoryQuantity) {
      inventoryQuantity = parseInt(inventoryQuantity);
      if(inventoryQuantity === 0) {
        this.labelInitial.classList.add('not-visible');
        this.labelInStock.classList.add('not-visible');
        this.labelOutOfStock.classList.remove('not-visible');
      }
      else if (inventoryQuantity > 0) {
        this.labelInitial.classList.add('not-visible');
        this.labelInStock.classList.remove('not-visible');
        this.labelOutOfStock.classList.add('not-visible');
      }
    }
  }

  window.Quickshop = Quickshop;
  customElements.define('quick-shop', Quickshop);
}

